import Action from './baseActions';
import { SharingSettingsTypes } from '../../models';

export enum SharingSettingsActionsTypes {
  LOAD_SHARING_SETTINGS = 'sharing_settings/load',
  LOADING_SHARING_SETTINGS = 'sharing_settings/loading',
  LOADED_SHARING_SETTINGS = 'sharing_settings/loaded',
  LOADING_SHARING_SETTINGS_FAILED = 'sharing_settings/loading_failed',

  LOAD_SELECTED_SHARING_SETTINGS = 'sharing_settings/load_selected',
  LOADING_SELECTED_SHARING_SETTINGS = 'sharing_settings/loading_selected',
  LOADED_SELECTED_SHARING_SETTINGS = 'sharing_settings/loaded_selected',
  LOADING_SELECTED_SHARING_SETTINGS_FAILED = 'sharing_settings/loading_failed_selected',

  SHARE_WITH_USER = 'sharing_settings/share_with_user',
  SHARING_WITH_USER = 'sharing_settings/sharing_with_user',
  SHARED_WITH_USER = 'sharing_settings/shared_with_user',
  SHARING_WITH_USER_FAILED = 'sharing_settings/sharing_with_user_failed',

  SHARE_WITH_GROUP = 'sharing_settings/share_with_group',
  SHARING_WITH_GROUP = 'sharing_settings/sharing_with_group',
  SHARED_WITH_GROUP = 'sharing_settings/shared_with_group',
  SHARING_WITH_GROUP_FAILED = 'sharing_settings/sharing_with_group_failed',

  SHARE_WITH_WORKSPACE = 'sharing_settings/share_with_workspace',
  SHARING_WITH_WORKSPACE = 'sharing_settings/sharing_with_workspace',
  SHARED_WITH_WORKSPACE = 'sharing_settings/shared_with_workspace',
  SHARING_WITH_WORKSPACE_FAILED = 'sharing_settings/sharing_with_workspace_failed',

  SHARED_WITH_PUBLIC = 'sharing_settings/with_public',

  UNSET_SHARING_SETTINGS = 'sharing_settings/unset',
}

type LoadedSharingSettings = {
  type: SharingSettingsTypes;
  uid: string;
  settings: any;
}

// Interfaces

export interface ILoadSharingSettingsAction extends Action {
  type: SharingSettingsActionsTypes.LOAD_SHARING_SETTINGS;
  payload: {
    type: SharingSettingsTypes,
    uid: string;
  }
}

export interface ILoadingSharingSettingsAction extends Action {
  type: SharingSettingsActionsTypes.LOADING_SHARING_SETTINGS;
  payload: SharingSettingsTypes;
}

export interface ILoadedSharingSettingsAction extends Action {
  type: SharingSettingsActionsTypes.LOADED_SHARING_SETTINGS;
  payload: LoadedSharingSettings;
}

export interface ILoadingSharingSettingsFailedAction extends Action {
  type: SharingSettingsActionsTypes.LOADING_SHARING_SETTINGS_FAILED;
  payload: SharingSettingsTypes;
}

export interface ILoadSelectedSharingSettingsAction extends Action {
  type: SharingSettingsActionsTypes.LOAD_SELECTED_SHARING_SETTINGS;
  payload: {
    type: SharingSettingsTypes;
    uidArr: string[];
  }
}

export interface ILoadingSelectedSharingSettingsAction extends Action {
  type: SharingSettingsActionsTypes.LOADING_SELECTED_SHARING_SETTINGS;
}

export interface ILoadedSelectedSharingSettingsAction extends Action {
  type: SharingSettingsActionsTypes.LOADED_SELECTED_SHARING_SETTINGS;
  payload: any;
}

export interface ILoadingSelectedSharingSettingsFailedAction extends Action {
  type: SharingSettingsActionsTypes.LOADING_SELECTED_SHARING_SETTINGS_FAILED;
}

export interface IUnsetSharingSettingsAction extends Action {
  type: SharingSettingsActionsTypes.UNSET_SHARING_SETTINGS;
  payload: SharingSettingsTypes;
}

export interface IShareWithUserAction extends Action {
  type: SharingSettingsActionsTypes.SHARE_WITH_USER;
  payload: {
    type: SharingSettingsTypes;
    uid: string;
    userUid: string;
    permission: string;
  }
}

export interface ISharingWithUserAction extends Action {
  type: SharingSettingsActionsTypes.SHARING_WITH_USER;
}

export interface ISharedWithUserAction extends Action {
  type: SharingSettingsActionsTypes.SHARED_WITH_USER;
  payload: {
    type: SharingSettingsTypes;
    uid: string;
    value: any;
  }
}

export interface ISharingWithUserFailedAction extends Action {
  type: SharingSettingsActionsTypes.SHARING_WITH_USER_FAILED;
}

export interface IShareWithGroupAction extends Action {
  type: SharingSettingsActionsTypes.SHARE_WITH_GROUP;
  payload: {
    type: SharingSettingsTypes;
    uid: string;
    groupUid: string;
    permission: string;
  }
}

export interface ISharingWithGroupAction extends Action {
  type: SharingSettingsActionsTypes.SHARING_WITH_GROUP;
}

export interface ISharedWithGroupAction extends Action {
  type: SharingSettingsActionsTypes.SHARED_WITH_GROUP;
  payload: {
    type: SharingSettingsTypes;
    uid: string;
    value: any;
  }
}

export interface ISharingWithGroupFailedAction extends Action {
  type: SharingSettingsActionsTypes.SHARING_WITH_GROUP_FAILED;
}

export interface IShareWithWorkspaceAction extends Action {
  type: SharingSettingsActionsTypes.SHARE_WITH_WORKSPACE;
  payload: {
    type: SharingSettingsTypes;
    uid: string;
    permission: string;
  };
}

export interface ISharingWithWorkspaceAction extends Action {
  type: SharingSettingsActionsTypes.SHARING_WITH_WORKSPACE;
}

export interface ISharedWithWorkspaceAction extends Action {
  type: SharingSettingsActionsTypes.SHARED_WITH_WORKSPACE;
  payload: {
    type: SharingSettingsTypes;
    uid: string;
    value: any;
  }
}

export interface ISharingWithWorkspaceFailedAction extends Action {
  type: SharingSettingsActionsTypes.SHARING_WITH_WORKSPACE_FAILED;
}

export interface ISharedWithPublicAction extends Action {
  type: SharingSettingsActionsTypes.SHARED_WITH_PUBLIC;
  payload: {
    type: SharingSettingsTypes;
    uid: string;
    value: boolean;
  }
}

// Functions

export function loadSharingSettings(type: SharingSettingsTypes, uid: string): ILoadSharingSettingsAction {
  return {
    type: SharingSettingsActionsTypes.LOAD_SHARING_SETTINGS,
    payload: {
      type,
      uid,
    }
  }
}

export function loadingSharingSettings(type: SharingSettingsTypes): ILoadingSharingSettingsAction {
  return {
    type: SharingSettingsActionsTypes.LOADING_SHARING_SETTINGS,
    payload: type,
  }
}

export function loadedSharingSettings(
  type: SharingSettingsTypes,
  uid: string, // loaded for
  settings: any,
): ILoadedSharingSettingsAction {
  return {
    type: SharingSettingsActionsTypes.LOADED_SHARING_SETTINGS,
    payload: {
      type,
      uid,
      settings,
    }
  }
}

export function loadingSharingSettingsFailed(type: SharingSettingsTypes): ILoadingSharingSettingsFailedAction {
  return {
    type: SharingSettingsActionsTypes.LOADING_SHARING_SETTINGS_FAILED,
    payload: type,
  }
}

export function loadSelectedSharingSettings(
  type: SharingSettingsTypes,
  uidArr: string[]
): ILoadSelectedSharingSettingsAction {
  return {
    type: SharingSettingsActionsTypes.LOAD_SELECTED_SHARING_SETTINGS,
    payload: {
      type,
      uidArr,
    }
  }
}

export function loadingSelectedSharingSettings(): ILoadingSelectedSharingSettingsAction {
  return {
    type: SharingSettingsActionsTypes.LOADING_SELECTED_SHARING_SETTINGS,
  }
}

export function loadedSelectedSharingSettings(
  type: SharingSettingsTypes,
  settings: LoadedSharingSettings[]
): ILoadedSelectedSharingSettingsAction {
  return {
    type: SharingSettingsActionsTypes.LOADED_SELECTED_SHARING_SETTINGS,
    payload: settings,
  }
}

export function loadingSelectedSharingSettingsFailed(): ILoadingSelectedSharingSettingsFailedAction {
  return {
    type: SharingSettingsActionsTypes.LOADING_SELECTED_SHARING_SETTINGS_FAILED,
  }
}

export function unsetSharingSettings(type: SharingSettingsTypes): IUnsetSharingSettingsAction {
  return {
    type: SharingSettingsActionsTypes.UNSET_SHARING_SETTINGS,
    payload: type,
  }
}

export function shareWithUser(
  type: SharingSettingsTypes,
  uid: string,
  userUid: string,
  permission: string
): IShareWithUserAction {
  return {
    type: SharingSettingsActionsTypes.SHARE_WITH_USER,
    payload: {
      type,
      uid,
      userUid,
      permission,
    }
  }
}

export function sharingWithUser(): ISharingWithUserAction {
  return {
    type: SharingSettingsActionsTypes.SHARING_WITH_USER,
  }
}

export function sharedWithUser(type: SharingSettingsTypes, uid: string, value: any): ISharedWithUserAction {
  return {
    type: SharingSettingsActionsTypes.SHARED_WITH_USER,
    payload: {
      type,
      uid,
      value,
    }
  }
}

export function sharingWithUserFailed(): ISharingWithUserFailedAction {
  return {
    type: SharingSettingsActionsTypes.SHARING_WITH_USER_FAILED,
  }
}

export function shareWithGroup(
  type: SharingSettingsTypes,
  uid: string,
  groupUid: string,
  permission: string
): IShareWithGroupAction {
  return {
    type: SharingSettingsActionsTypes.SHARE_WITH_GROUP,
    payload: {
      type,
      uid,
      groupUid,
      permission,
    }
  }
}

export function sharingWithGroup(): ISharingWithGroupAction {
  return {
    type: SharingSettingsActionsTypes.SHARING_WITH_GROUP,
  }
}

export function sharedWithGroup(type: SharingSettingsTypes, uid: string, value: any): ISharedWithGroupAction {
  return {
    type: SharingSettingsActionsTypes.SHARED_WITH_GROUP,
    payload: {
      type,
      uid,
      value,
    }
  }
}

export function sharingWithGroupFailed(): ISharingWithGroupFailedAction {
  return {
    type: SharingSettingsActionsTypes.SHARING_WITH_GROUP_FAILED,
  }
}

export function shareWithWorkspace(
  type: SharingSettingsTypes,
  uid: string,
  permission: string
): IShareWithWorkspaceAction {
  return {
    type: SharingSettingsActionsTypes.SHARE_WITH_WORKSPACE,
    payload: {
      type,
      uid,
      permission,
    }
  }
}

export function sharingWithWorkspace(): ISharingWithWorkspaceAction {
  return {
    type: SharingSettingsActionsTypes.SHARING_WITH_WORKSPACE,
  }
}

export function sharedWithWorkspace(type: SharingSettingsTypes, uid: string, value: any): ISharedWithWorkspaceAction {
  return {
    type: SharingSettingsActionsTypes.SHARED_WITH_WORKSPACE,
    payload: {
      type,
      uid,
      value,
    }
  }
}

export function sharingWithWorkspaceFailed(): ISharingWithWorkspaceFailedAction {
  return {
    type: SharingSettingsActionsTypes.SHARING_WITH_WORKSPACE_FAILED,
  }
}

export function sharedWithPublic(
  type: SharingSettingsTypes,
  uid: string,
  isPublic: boolean,
): ISharedWithPublicAction {
  return {
    type: SharingSettingsActionsTypes.SHARED_WITH_PUBLIC,
    payload: {
      type,
      uid,
      value: isPublic,
    }
  }
}

export type SharingSettingsActions =
  | ILoadSharingSettingsAction
  | ILoadingSharingSettingsAction
  | ILoadedSharingSettingsAction
  | ILoadingSharingSettingsFailedAction
  | ILoadSelectedSharingSettingsAction
  | ILoadingSelectedSharingSettingsAction
  | ILoadedSelectedSharingSettingsAction
  | ILoadingSelectedSharingSettingsFailedAction
  | IUnsetSharingSettingsAction
  | IShareWithUserAction
  | ISharingWithUserAction
  | ISharedWithUserAction
  | ISharingWithUserFailedAction
  | IShareWithGroupAction
  | ISharingWithGroupAction
  | ISharedWithGroupAction
  | ISharingWithGroupFailedAction
  | IShareWithWorkspaceAction
  | ISharingWithWorkspaceAction
  | ISharedWithWorkspaceAction
  | ISharingWithWorkspaceFailedAction
  | ISharedWithPublicAction
;
